import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';

/**
 * Quiet closing band — one job, one CTA (Shopify end-of-page rhythm).
 */
const MarketingClosingCta = () => {
  return (
    <section className="bg-m-canvas-light px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-5xl text-center">
        <h2 className="marketing-section-title mb-4 text-m-ink">
          Your something starts somewhere
        </h2>
        <p className="marketing-body-lg mx-auto mb-10 max-w-xl text-m-ink-muted">
          Dummy promise for now — browse vendors, compare packages, and book the
          night that feels inevitable.
        </p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/browse-vendors" className="marketing-btn marketing-btn-ink gap-2">
            Browse vendors
            <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/how-it-works"
            className="inline-flex h-[var(--m-control-h)] items-center justify-center gap-2 rounded-full border border-m-border-light px-6 text-sm font-medium text-m-ink transition-colors hover:border-m-ink"
          >
            How it works
          </Link>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingClosingCta;
